// implements: CRS-V21-RT-001 (Sidebar Realtime Provider)
import React, { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { initSidebarSSE, disconnectSidebarSSE } from './sidebarSSE';

export function SidebarRealtimeProvider({ children }: { children: React.ReactNode }) {
  const qc = useQueryClient();

  useEffect(() => {
    initSidebarSSE(qc);
    return () => {
      disconnectSidebarSSE();
    };
  }, [qc]);

  return <>{children}</>;
}
